// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"88d7586b","168":"baf92c1f","383":"86d74976","467":"e57786f4","476":"ad5b50af","555":"518bb5f6","623":"11dbc358","650":"ec20adcf","798":"93bfe42b"}[chunkId] + ".chunk.js";
};